//
//
//
//
//
//

import CommonList2 from '@/components/nav_common/CommonList2.vue'
import { Author } from '@/models/author'

export default {
  data () {
    return {
      selectDynasty: '不限',
      conditions: [
        {
          name: '朝代',
          list: [
            // {text: '上古'},
            // {text: '夏'},
            {text: '商'},
            {text: '周'}, // 合并为先秦
            { text: '秦' },
            { text: '汉' },
            { text: '三国' },
            { text: '晋' },
            { text: '南北朝' },
            { text: '隋' },
            { text: '唐' },
            { text: '五代' },
            { text: '宋' },
            { text: '金' },
            // {text: '辽'},
            { text: '元' },
            { text: '明' },
            { text: '清' },
            { text: '现代' }
          ]
        }
      ]
    }
  },

  props: {
    page: {
      type: Number,
      default: 1
    },
    perPage: {
      type: Number,
      default: 10
    }
  },

  watch: {
    page: {
      handler (newVal, oldVal) {
        if (newVal !== oldVal) {
          this.getAuthorData()
        }
      },
      immediate: false
    }
  },

  components: {
    CommonList2
  },

  methods: {
    getAuthorData () {
      if (this.selectDynasty === '不限') {
        this.getAuthorsUnlimited()

        return
      }

      Author.getAuthorsIncludeCountByDynasty(this.selectDynasty, this.page, this.perPage).then((result) => {
        this.$emit('get-count', result.pageCount)
        this.$emit('get-author-data', result.authors)
      })
    },

    // dynastyObj 为data中List的每一个数据
    handleClickDynasty (dynastyObj) {
      let dynasty = dynastyObj.text

      if (dynasty !== this.selectDynasty) {
        if (dynasty === '五代') {
          dynasty = '五代十国'
        }
  
        this.selectDynasty = dynasty
        this.$emit('change-page', 1)
        this.getAuthorData()
      }
    },
    handleClickUnlimit () {
      if (this.selectDynasty !== '不限') {
        this.selectDynasty = '不限'
        this.$emit('change-page', 1)
        this.getAuthorData()
      }
    },

    getAuthorsUnlimited () {
      return Author.getHotAuthorsIncludeCountByLikers(this.page, this.perPage).then((result) => {
        this.$emit('get-author-data', result.authors)
        this.$emit('get-count', result.pageCount)
      })
    }
  },
  created () {
    this.getAuthorsUnlimited()
  }
}



// WEBPACK FOOTER //
// ./src/components/nav_author/AuthorDynastyList.vue